import { useEffect, useRef, useState } from 'react';

import { TitleContainer, TitleOverflow } from './Ellipsing.styles';

interface EllipsingProps {
  text: string;
}

const Ellipsing = ({ text }: EllipsingProps) => {
  const textRef = useRef<HTMLDivElement | null>(null);
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      const containerWidth = containerRef.current?.offsetWidth;
      const textWidth = textRef.current?.scrollWidth;

      // Set overflow status
      setIsOverflowing(textWidth > containerWidth);
    };

    // Check on initial mount and window resize
    window.addEventListener('resize', checkOverflow);
    checkOverflow();

    return () => {
      window.removeEventListener('resize', checkOverflow);
    };
  }, [text]);

  return (
    <TitleContainer ref={containerRef}>
      <TitleOverflow ref={textRef} title={isOverflowing ? text : undefined}>
        {text}
      </TitleOverflow>
    </TitleContainer>
  );
};

export default Ellipsing;
